import { adminData } from "~/admin/data";

export const PROPS_CAN_DELETE = "canDelete";
export const PROPS_ORG_LEVEL_PRODUCT_GUID = "orgLevelProductGuid";
export const PROPS_PRODUCTS = "products";
export const PROPS_PRODUCT_NAMES = "productNames";
export const PROPS_ORG_LEVELS = "orgLevels";
export const PROPS_ORG_LEVEL_NAMES = "orgLevelNames";
export const PROPS_CREATED_DATE = "createdDate";
export const PROPS_MODIFIED_DATE = "modifiedDate";
export const PROPS_STATE_ABBREVIATION = adminData.PROPS_STATE_ABBREVIATION;

export const PROPS_ORG_LEVEL_NAME = "orgLevelName";
export const PROPS_ORG_LEVEL_CITY = "city";
export const PROPS_ORG_LEVEL_STATE = "state";
